import { IDocumento } from './../idocumento';
export interface IFileUploadResponse {
    documento?: IDocumento;
    path?: string;
    size?: number;
    msg?: string;
    status?: string;
}